import Image from 'app/Components/Shared/Image/image';
import CellularIcon from '../OrderSuccess/images/icon-24-cellular-black.svg';
import React from 'react';
import { Row, Col } from 'reactstrap';

const CellularItem = (props) => {

  const icons = ['icon-24-light.svg', 'icon-24-wifi.svg', 'icon-24-my-bill.svg'];
  const getIconByIndex = (index) => {
    try {
      return icons[index];
    } catch (error) {
      console.error(error);
    }
  };


  return (
    <>
      {props.orderItem.textItems == undefined ? null : (
        <div className='finish-banner-new'>
          <div className='modeContainer'>
            <div className='phoneContainer'>
              <div className='phone-items-wrapper'>
                {props.orderItem.phoneNumbers.map((phone) => (
                  <div className='phoneItem'>
                    <span className='phoneIcon'>
                      <Image src={CellularIcon} />
                    </span>
                    <span className='phoneNumber'>{phone.replace(/^(.{3})(.*)$/, '$1-$2')}</span>
                  </div>
                ))}
              </div>
              <div className='mode-name-wrapper'>
                <>
                  <p className='modeName'>{props.orderItem.modeDisplayName}</p>
                </>
              </div>
            </div>
          </div>
          <div className='modeContent'>
            {props.orderItem.textItems &&
              props.orderItem.textItems.map((textItem, index) => (
                <div className='itemContainer'>
                  <span className='lightIcon'>
                    <Image src={require('../images/' + getIconByIndex(index))} />
                  </span>
                  <div>
                    {index == 0 &&
                      <>
                        <span className='titleItem'>{props.orderItem?.title}</span>
                        <br />
                      </>
                    }
                    <span className='textItem'>{textItem}</span>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default CellularItem;
